export enum SideBarType {
  FULL = 'full',
  ICON_BAR = 'iconbar',
  OVERLAY = 'overlay',
  MINI_SIDE_BAR = 'mini-sidebar'
}
